import { Component } from 'react';
import axios from 'axios';
import { analyticsApi, utilizationApi } from '../../services';
import { ContractsManager } from '../../managers';
import { Tabbar } from '../tailwind/molecules';
import { handleAppError } from '../handlers'
import { Breadcrumb, Heading, Spinner } from '../common/atoms'
import MentalWellnessEWAP from './EWAP-analytics/MentalWellnessEWAP';
import EWAPBarGraphData from './EWAP-analytics/EWAPBarGraphData'
import { Spin } from 'antd';
let token = '';

class MentalWellness extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading : true,
      spinnerLoading : false,
      NoDataFrame: false,
      basicConfigValues : {
        filters: [],
        config: {
          chart: {},
          title: {text: '', align: 'left'},
          subtitle: { text: '', align: 'left' },
          xAxis: {},
          yAxis: {},
          credits: {
            enabled: false
          },
          series: []
        }
      }
    };
  }

  fetchCompleteData = async (contractId, startDate, endDate) => {
    token = axios.CancelToken.source();

    var promise1 = analyticsApi.getEAPAnalytics({ contractId, startDate, endDate, cancelToken: token.token });
    var promise2 = analyticsApi.getEAPLineDataAnalytics({ contractId, startDate, endDate, cancelToken: token.token });
    var promise3 = analyticsApi.getEAPBarDataAnalytics({contractId, startDate, endDate, cancelToken: token.token });
   
    Promise.all([promise1, promise2, promise3])
      .then((values) => {
        var resp_arr = values.map((resp) => resp.data);
        var metricObj = resp_arr[0]
        var lineGraphData = resp_arr[1]
        let last_30days = resp_arr[2].is_running_contract ? ( new EWAPBarGraphData(resp_arr[2]?.last_30days)) : {}
        let contractPeriod = new EWAPBarGraphData(resp_arr[2]?.contract_period) ?? {}
        var barGraphData = resp_arr[2].is_running_contract ? contractPeriod : last_30days
        let fullGraphData = {last_30days : last_30days, contract_period : contractPeriod}
        let selectedOptions = lineGraphData?.is_running_contract ? ['Contract Period', 'Last 30 Days'] : ['Contract Period']
        let value1 = Object.keys(barGraphData) ? true : false
        let value2 = Object.keys(lineGraphData) ? true : false       
        this.setState({loading: false , spinnerLoading : false, lineGraphPresent : value1, barGraphPresent : value2, fullGraphData: fullGraphData,   metricObj : metricObj, lineGraphData :lineGraphData, barGraphData : barGraphData, selectedItem1 :  selectedOptions[0], selectedItem2 :  selectedOptions[0], selectedOptions})
      })
      .catch((err) => 
      { handleAppError(err)
        this.setState({loading:false, spinnerLoading :false, lineGraphPresent: true, barGraphPresent : true})
      }
      );
  };

  fetchContractDetails = () => {
    const contractId = parseInt(this.props.location.state?.contractId, 10)

    utilizationApi.fetchContracts(
      {},
      (resp) => {
        const contractObj = new ContractsManager(resp.data, 'EWAP');
        const formattedData = contractObj.formattedData
        const selectedContractObj =  formattedData.find(e => e.contract_id === contractId) ?? formattedData[0]
        this.setState({
          contracts: formattedData,
          selectedContractObj: selectedContractObj,
          contractId: selectedContractObj.contract_id,
          startDate: selectedContractObj.start_date,
          endDate: selectedContractObj.end_date,
          overallId: formattedData[0].contract_id
        });
      },
      (err) => {
        handleAppError(err);
      }
    );
  };

  componentDidMount() {
    this.fetchContractDetails();
  }

  componentWillUnmount() {
    token && token.cancel();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.state.contractId && prevState.contractId !== this.state.contractId) {
      token && token.cancel();
      this.fetchCompleteData(this.state.contractId, this.state.startDate, this.state.endDate);
    }
  }
  toggleHelp = () => this.props.toggleHelp('Health_checks');

  content = () => {
   return <><MentalWellnessEWAP  {...this.state} changeContractTo = {(e) => this.changeContractTo(e)}/></>
  };

  changeContractId = (contractId) => {
    contractId = parseInt(contractId, 10)
    const { contracts = [], selectedContractObj } = this.state
    const newContract = contracts.find(e => e.contract_id === contractId)
    const { contract_id: oldContractId } = selectedContractObj

    if (contractId && oldContractId !== contractId) {
      this.setState({
        contractId: newContract.contract_id,
        startDate: newContract.start_date,
        endDate: newContract.end_date,
        selectedContractObj: newContract,
        loading : true,
        show_low_screen: false,
      });
    }
  };
  
  changeContractTo = ({id, val}) =>{
    if(val === 'first') {
      let value = id === 1 ? 'Last 30 Days' : 'Contract Period'
      let getBarGraphData = value === 'Last 30 Days' ? this.state.fullGraphData?.['last_30days'] : this.state.fullGraphData?.['contract_period']
      this.setState({...this.state, selectedItem1 : value, barGraphData : getBarGraphData}) 
    }
    else {
      let value = id === 3 ? 'Last 30 Days' : 'Contract Period'
      this.setState({...this.state, selectedItem2 : value}) 
    }
  }
  render() {
    const { contracts = [], selectedContractObj, spinnerLoading } = this.state;
    const tabbarList = contracts.map(e => e.text)
    const tabbarIds = contracts.map(e => e.contract_id ?? 'overall-id')

    return (
      <>
        {spinnerLoading ? 
           <div className='spiner'>
           <Spin size="large"/>
           </div>
          : 
         <> 
        <div className='flex flex-row justify-between'>
          <div>
            <Breadcrumb
              list={[
                { text: 'Analytics', link: '#' },
                { text: 'Mental wellness', link: '/mental-wellness' }
              ]}
              classes='mb-1'
            />
              {typeof this.state.selectedContractObj !== 'undefined' && (
                <Heading mainHeading='Mental wellness' subHeading='Analysis on the mental health and wellbeing of the organization' mainClasses='text-gray-900 font-semibold leading-5 text-xl mb-0 mt-1.5' subClasses='text-gray-500 leading-4 text-sm mt-2 mb-0' />
              )}
          </div>  
        </div>
        <Tabbar
          list={tabbarList}
          ids={tabbarIds}
          loading={!selectedContractObj}
          classes='mt-5'
          newPageId={selectedContractObj ? (selectedContractObj.contract_id ?? 'overall-id') : ''}
          changeHandler={this.changeContractId}
        />
        {this.content()}
        </>
      }  
      </>
    );
  }
}

export default MentalWellness;
